import _ from 'lodash';
import { mapState } from 'vuex';
import { permissions, NotFound } from '~';

import CampaignLab from '@/components/lab/campaign/Campaign.vue';
import CampaignRabbit from '@/components/rabbit/campaign-wrapper/CampaignWrapper.vue';

import CreativeLab from '@/components/lab/creative/Creative.vue';
import CreativeRabbit from '@/components/rabbit/creative/Creative.vue';

import CustomerLab from '@/components/customer/Customer.vue';
import CustomersLab from '@/components/customers/Customers.vue';

const COMPONENT_MAP = {
  campaign: {
    lab: 'CampaignLab',
    rabbit: 'CampaignRabbit',
  },
  creative: {
    lab: 'CreativeLab',
    rabbit: 'CreativeRabbit',
  },
  customer: {
    lab: 'CustomerLab',
    rabbit: 'NotFound',
  },
  customers: {
    lab: 'CustomersLab',
    rabbit: 'CampaignRabbit',
  },
};

export default {
  components: {
    CampaignLab,
    CampaignRabbit,
    CreativeLab,
    CreativeRabbit,
    CustomerLab,
    CustomersLab,
    NotFound,
  },
  props: {
    component: String,
  },
  computed: {
    ...mapState('auth', ['user']),
    showLab() {
      return permissions.canGlobal(this.user, 'User', ['loginLab']);
    },
    componentName() {
      const key = this.showLab ? 'lab' : 'rabbit';
      return _.get(COMPONENT_MAP, `${this.component}.${key}`, false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/switcher/Switcher.js